<template>
    <div>
        <vx-card title="Vehicle Usage/History">
            <template slot="actions" class="text-grey">
                <a href="javascript:void(0)"  @click.prevent="$parent.selected_vehicle_id = null">
                    <feather-icon icon="ChevronLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    Return to vehicle timesheet
                </a>
            </template>
            <!-- Vehicle Counts -->
            <div class="vx-row m-0 pb-5 mb-5  shadow">
                <div class="vx-col w-full mb-5" v-if="vehicle_detail">
                    <h4 class="font-bold">{{ vehicle_detail.name }} {{ vehicle_detail.brand }}</h4>
                    <div class="vx-row m-0">
                        <table class="mt-2 mt-xl-0 w-1/3">
                            <tr>
                                <th class="pb-50"><label>ID :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.vehical_id}} </td>
                            </tr>
                            <tr>
                                <th class="pb-50"><label>Rego# :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.number}} </td>
                            </tr>
                            <tr>
                                <th class="pb-50"><label>Year :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.year}} </td>
                            </tr>
                        </table>
                        <table class="mt-2 mt-xl-0 w-1/3">
                            <tr>
                                <th class="pb-50"><label>Type :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.type}} </td>
                            </tr>
                            <tr>
                                <th class="pb-50"><label>Color :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.colour}} </td>
                            </tr>
                            <tr v-if="vehicle_detail.office_id">
                                <th class="pb-50"><label>Office :</label></th>
                                <td class="pb-50"> {{ vehicle_detail.office_id.office_name}} </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- Total Trips -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left ">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_trips ? total_trips : 0}}</h6>
                            <span>Trips</span>
                        </div>
                        <feather-icon icon="TrendingUpIcon" class="p-3 inline-flex rounded-full text-primary" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Distance -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_distances | validNumber }} Km</h6>
                            <span>Distance</span>
                        </div>
                        <feather-icon icon="UserIcon" class="p-3 inline-flex rounded-full text-info" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Time -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_time | convertHoursMinutes }}</h6>
                            <span>Time</span>
                        </div>
                        <feather-icon icon="BoxIcon" class="p-3 inline-flex rounded-full text-danger" :style="{background: `rgba(var(--vs-danger),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Fuel Amount -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">${{ total_fuel_amount ? total_fuel_amount : 0}}</h6>
                            <span>Fuel</span>
                        </div>
                        <feather-icon icon="DollarSignIcon" class="p-3 inline-flex rounded-full text-success" :style="{background: `rgba(var(--vs-success),.10)`}"></feather-icon>
                    </div>
                </div>
            </div>
            <!-- Filters -->
            <form class="w-full mt-6 mb-1" autocomplete="off" data-vv-scope="filter-form">
                <div class="vx-row">
					<div class="vx-col sm:w-1/4 w-full mb-2">
                        <label>Select Driver</label>
						<v-select class="w-full" v-model="filter_driver_id" :options="user_list" label="name" index="id" placeholder="Select Driver" />
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2">
						<label for class="vs-input--label">Start Date</label>
                        <flat-pickr
                        :config="configStartDate"
                        @on-change="onStartDateChange"
                        class="vs-inputx vs-input--input normal time"
                        label="Start Date"
                        v-validate="end_date ? 'required' : ''"
                        name="start_date"
                        v-model="start_date"
                        autocomplete="off"
                        placeholder="Select Start Date"
                        />
                        <span class="text-danger text-sm">{{ errors.first('filter-form.start_date') }}</span>
					</div>
                    <div class="vx-col sm:w-1/4 w-full mb-2">
                        <label for class="vs-input--label">End Date</label>
                        <flat-pickr
                        :config="configEndDate"
                        class="vs-inputx vs-input--input normal time"
                        label="End Date"
                        v-validate="start_date ? 'required' : ''"
                        name="end_date"
                        v-model="end_date"
                        autocomplete="off"
                        placeholder="Select End Date"
                        @on-change="onEndDateChange"
                        />
                        <span class="text-danger text-sm">{{ errors.first('filter-form.end_date') }}</span>
					</div>
                    <div class="vx-col sm:w-1/4 w-full mb-2 inline-flex">
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-search" title="Search" @click.prevent="filterHistory()"></vs-button>
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-download" title="Export CSV" @click.prevent="filterHistory('export_csv')"></vs-button>
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-file-text" title="Export PDF" @click.prevent="filterHistory('export_pdf')"></vs-button>
                        <vs-button class="mt-6" color="warning" type="filled" icon-pack="feather" icon="icon-x" title="Clear" @click.prevent="clearFilter()"></vs-button>
					</div>
				</div>
            </form>
            
            <div class="w-full m-0">
                <vs-table :data="history">
                    <template slot="thead">
                        <!-- <vs-th> </vs-th> -->
                        <vs-th> Date </vs-th>
                        <vs-th> Odometer Start </vs-th>
                        <vs-th> Odometer End </vs-th>
                        <vs-th> Odometer Total </vs-th>
                        <vs-th> Time Start </vs-th>
                        <vs-th> Time End </vs-th>
                        <vs-th> Time Total </vs-th>
                        <vs-th> Fuel Odometer  </vs-th>
                        <vs-th> Fuel Volume </vs-th>
                        <vs-th> Fuel Value</vs-th>
                        <vs-th> Driver </vs-th>
                        <vs-th style="width: 10%;">Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                            <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}</vs-td>
                            <vs-td>{{ tr.start_km }}</vs-td>
                            <vs-td>{{ tr.end_km  }}</vs-td>
                            <vs-td>{{ (tr.end_km - tr.start_km) }}</vs-td>
                            <vs-td>{{ tr.start_time ? tr.start_time : '-' | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm A') }}</vs-td>
                            <vs-td>{{ tr.end_time ? tr.end_time : '-' | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm A') }}</vs-td>
                            <vs-td>{{ tr.diffrence_in_miliseconds | convertHoursMinutes}}</vs-td>
                            <vs-td>{{ tr.fuelData && tr.fuelData.receipt_no ? tr.fuelData.receipt_no : '-' }}</vs-td>
                            <vs-td>{{ tr.fuelData && tr.fuelData.quantity ? tr.fuelData.quantity : 0 }}</vs-td>
                            <vs-td>${{ tr.fuelData && tr.fuelData.amount ? tr.fuelData.amount.toFixed(2) : 0.00 }}</vs-td>
                            <vs-td>{{ tr.user_id ? tr.user_id.full_name : '-' }}</vs-td>
                            <vs-td>
                                <vs-button
                                color="#F4B400"
                                type="filled"
                                class="mr-2 mb-2 float-left"
                                icon-pack="feather"
                                icon="icon-edit-2"
                                size="small"
                                title="Edit User"
                                @click="popupActive=true,odometerend=tr.end_km,odometerstart=tr.start_km,odo_id=tr._id"
                                ></vs-button>
                                <vs-button
                                color="#DB4437"
                                type="filled"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                size="small"
                                title="Delete User"
                                @click.stop="confirmDelete(tr._id)"
                                ></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                
                <div style="height:50px;" v-if="history.length">
                    <div class="float-right mt-2">
                        <vs-pagination ref="pagination2" :total="total_page" v-model="current_page"></vs-pagination>
                    </div>
                </div>
            </div>

        
            
            <vs-popup :active.sync="popupActive" title="Edit Odometer Readings">
                <div>
                     <form class="w-full" autocomplete="off">       
                        <div class="vx-row mb-2">
                            <div class="vx-col md:w-1/2 form-group w-full mb-2">
                                <vs-input
                                class="w-full"
                                label="Odometer Start"
                                name="odometerstart"
                                v-model="odometerstart"
                                autocomplete="off"
                                />
                            </div>
                            <div class="vx-col md:w-1/2 form-group w-full mb-2">
                                <vs-input
                                class="w-full"
                                label="Odometer End"
                                name="odometerend"
                                v-model="odometerend"
                                autocomplete="off"
                                />
                            </div>
                        </div>
                        <div class="vx-row my-5">
                            <div class="vx-col w-full">
                                <vs-button
                                class="mt-1 m-auto gradient-btn" @click="updateOdometerReadings()">
                                save
                                </vs-button>
                                <vs-button 
                                class="mt-1 ml-4 m-auto gradient-btn" @click="cancelEditOdometer()"
                                >Cancel</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>
            
        </vx-card>
    </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
export default {
  props: {
    vehicle_id: {
      required: true,
      default: null,
      type: String
    },
  },
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
        popupActive: false,
        user_list: [],
        filter_driver_id: null,
        per_page: 10, 
        total_page: 1, 
        current_page: 1,
        vehicle_detail: {},
        total_trips: 0,
        total_distances: 0,
        total_time: 0,
        total_fuel_amount: 0,
        history: [],
        start_date: null,
        end_date: null,
        configStartDate: {
            minDate: null,
            maxDate: new Date(),
            dateFormat: "d/m/Y"
        },
        configEndDate: {
            maxDate: new Date(),
            dateFormat: "d/m/Y"
        },
        odometerend:null,
        odometerstart:null,
        odo_id:null,
    };
  },
  watch: {
    current_page(nv) {
      if (nv) {
        this.getVechicleHistory();
      }
    },
    filter_driver_id(nv){
        // this.getVechicleHistory(nv);
    }
  },
  created() {
  },
  mounted() {
    this.getAllUsers();
    if (this.vehicle_id) {
        this.getVechicleHistory();
    }
  },
  computed: {
  },
  methods: {
    /** Change start & end date configration */
    onStartDateChange(selectedDates, dateStr, instance) {
      this.$set(this.configEndDate, "minDate", dateStr);
    },
    onEndDateChange(selectedDates, dateStr, instance) {
      this.$set(this.configStartDate, "maxDate", dateStr);
    },
    /** Get all Office */
    async getAllUsers() {
        this.$vs.loading({ color: "primary" });

        let url = "user/getUsers";
        let input = {
            type: 'U',
        };
        let response_data = await this.axios
                            .get(url,{ params: input })
                            .then(response => {
                                let users = [];
                                response.data.data.forEach(element => {
                                    users.push({id:element.id, name:element.firstname+' '+element.lastname});
                                });
                                this.$vs.loading.close();
                                return users;
                            })
                            .catch(e => {
                                this.showError(e);
                            });
        if (response_data) {
            this.user_list = response_data;
        }
    },
    /** Filter vehicle data */
    filterHistory(export_data = false) {
      this.$validator.validateAll("filter-form").then(result => {
        if (result) {
            if (export_data == 'export_pdf') {
                let url = process.env.VUE_APP_API_URL + "/vehicleTimesheetGetSingle?pdf=true&vehicle_id="+this.vehicle_id;
                if (this.filter_driver_id) {
                    url += "&user_id="+this.filter_driver_id;
                }
                if (this.start_date && this.end_date) {
                    url += "&from_time="+this.start_date+"&to_time="+this.end_date;
                }
                if (this.$store.state.uInfo.id) {
                    url += "&login_id="+this.$store.state.uInfo.id;
                }
                window.open(url,"_blank");
            }else{
                this.getVechicleHistory(this.filter_driver_id,export_data,this.start_date,this.end_date);
            }
        }
      });
    },
    /** Clear filter */
    clearFilter(){
        this.$validator.reset("filter-form");
        this.errors.clear("filter-form");
        this.filter_driver_id = null;
        this.start_date = null;
        this.end_date = null;
    },

    // ===== Confirm Delete =====
    confirmDelete(id) {
        this.odo_id = id;
      // jquery call
      let text =
        "Deleting a user will remove all the data related to user and once deleted, it can not be reverted.   Are you sure you want to delete this Trip?";

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: text,
        acceptText: "Delete",
        accept: this.deleteHistory
      });
    },
    async deleteHistory(){
          this.$vs.loading({color: "primary"});
            let url = "vehicleTimesheetDeleteSingle?vinout_id="+this.odo_id;
            await this.axios
                .delete(url)
                .then(response => {
                    if(response.status == 200){
                        this.odo_id = null;
                        this.getVechicleHistory();
                    }
                })
                .catch(e => {
                    this.showError(e);
                });
    },
    /** Get vehicle history */
    async getVechicleHistory(user_id = null, export_data = false, start_date = null, end_date = null) {
        this.$vs.loading({ color: "primary" });
        let input = {
            vehicle_id: this.vehicle_id,
            user_id: user_id,
            from_time: start_date,
            to_time: end_date,
            login_id:this.$store.state.uInfo.id,
        };

        if (export_data) { // check export flag
            let export_input = {
                csv:true,
            }
            input = Object.assign(export_input,input);
        }else{ // pass pagination params for listing
            let pagination = {
                pageNo: this.current_page - 1,
                pageLimit: this.per_page
            }
            input = Object.assign(pagination,input);
        }

        let url = "vehicleTimesheetGetSingle";
        let response_data = await this.axios
                .get(url,{ params: input })
                .then(response => {
                    if (export_data == 'export_csv') {
                        let file_name = 'vehicle-history.csv';
                        if (this.vehicle_detail && this.vehicle_detail.number) {
                           file_name = this.vehicle_detail.number+'.csv'
                        }

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", file_name);
                        document.body.appendChild(link);
                        link.click();

                        this.$vs.loading.close();
                        return false;
                    }else{
                       this.$vs.loading.close();
                       return response.data.data;
                    }
                    
                })
                .catch(e => {
                    this.showError(e);
                    return null
                });

        
        if (response_data) {
            this.vehicle_detail = response_data.singleVehicleData[0] || {};
            this.total_trips = response_data.totalTrip || 0;
            this.total_distances = response_data.totalDistance || 0;
            this.total_time = response_data.totalTime || 0;
            this.total_fuel_amount = response_data.totalFuel.toFixed(2) || 0;
            this.history = response_data.data || [];
            this.total_page = response_data.pages;  
        }
        // show vehicle history
        this.show_vehicle_history = true;         
    },
    cancelEditOdometer(){
        this.popupActive=false;
        this.odometerend= null;
        this.odometerstart=null;
        this.odo_id=null;
    },
    updateOdometerReadings(){
        let input = {
            end_km:this.odometerend,
            start_km:this.odometerstart
        }
this.$vs.loading({color: "primary"});
      this.axios
        .post("/vehicleTimesheetUpdateSingle?vinout_id="+this.odo_id, input)
        .then(response => {
          if (response) {            
            this.$vs.loading.close();
            let text = "Timesheet has been approved successfully!!!";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            this.cancelEditOdometer();
            this.getVechicleHistory();
          }
        })
        .catch(e => {
          this.showError(e);
        });
      this.$vs.loading.close();
    }, 
  }
};
</script>

		